import comp from "./OverrideStandardRubricScore";
export default comp;
